let slowScanTimer = null;
let slowScanTimerCallback = null;

let slowScanBanner = null;
let slowScanText = null;
let currentSessionId = null;

const timeouts = {
  initiating: 20_000,
  clicking: 10_000,
  retrieving: 10_000,
  adjusted: 10_000
};

const states = {
  LOADING: "loading",
  INITIATED: "initiated",
  CLICKED: "clicked",
  RETRIEVED: "retrieved",
  SUCCESS: "success",
  FAILED: "failed",
};

const events = {
  LOAD_DONE: "LOAD_DONE",
  CLICK: "CLICK",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  TIMEOUT: "TIMEOUT",
};

const transitions = {
  [states.LOADING]: {
    [events.LOAD_DONE]: states.INITIATED,
    [events.TIMEOUT]: states.LOADING,
  },

  [states.INITIATED]: {
    [events.CLICK]: states.CLICKED,
    [events.PENDING]: states.RETRIEVED,
    [events.SUCCESS]: states.SUCCESS,
    [events.FAILED]: states.FAILED,
    [events.TIMEOUT]: states.INITIATED,
  },

  [states.CLICKED]: {
    [events.PENDING]: states.RETRIEVED,
    [events.SUCCESS]: states.SUCCESS,
    [events.FAILED]: states.FAILED,
    [events.TIMEOUT]: states.CLICKED,
  },

  [states.RETRIEVED]: {
    [events.SUCCESS]: states.SUCCESS,
    [events.FAILED]: states.FAILED,
    [events.TIMEOUT]: states.RETRIEVED,
  },

  [states.SUCCESS]: {},
  [states.FAILED]: {},
};

function resetUI() {
  if (slowScanTimer) {
    clearTimeout(
      slowScanTimer
    );

    slowScanTimer = null;
  }

  if (slowScanBanner) {
    slowScanBanner.classList.add(
      "d-none"
    );
  }
}

function startTimer(
  message,
  timeout
) {
  slowScanTimerCallback =
    () => {
      if (!slowScanBanner) {
        return;
      }

      if (slowScanText) {
        slowScanText.textContent =
          message;
      }

      slowScanBanner.classList.remove(
        "d-none"
      );
    };

  slowScanTimer =
    setTimeout(
      slowScanTimerCallback,
      timeout
    );
}

const statesConfig = {
  [states.LOADING]: {
    onEnter() {
      resetUI();

      startTimer(
        "Loading credential offer… please wait.",
        timeouts.adjusted
      );
    }
  },

  [states.INITIATED]: {
    onEnter() {
      resetUI();

      startTimer(
        "Try scanning the QR code again to continue.",
        timeouts.initiating
      );
    }
  },

  [states.CLICKED]: {
    onEnter() {
      resetUI();

      startTimer(
        "Please continue the credential issuance in your wallet.",
        timeouts.clicking
      );
    }
  },

  [states.RETRIEVED]: {
    onEnter() {
      resetUI();

      startTimer(
        "Waiting for your wallet to finish the credential issuance.",
        timeouts.retrieving
      );
    }
  },

  [states.SUCCESS]: {
    onEnter() {
      resetUI();

      window.location.href =
        "/success.html?sessionId=" +
        encodeURIComponent(
          currentSessionId
        );
    }
  },

  [states.FAILED]: {
    onEnter() {
      resetUI();

      window.location.href =
        "/fail.html?sessionId=" +
        encodeURIComponent(
          currentSessionId
        );
    }
  }
};

function createMachine({
                         initialState,
                         transitions,
                         states
                       }) {
  let state =
    initialState;

  function runEnter(
    newState
  ) {
    const config =
      states[newState];

    if (
      config &&
      config.onEnter
    ) {
      config.onEnter();
    }
  }

  function send(
    event
  ) {
    const next =
      transitions[state]?.[event] ??
      state;

    if (next === state) {
      return;
    }

    state =
      next;

    runEnter(
      state
    );
  }

  function getState() {
    return state;
  }

  runEnter(
    state
  );

  return {
    send,
    getState
  };
}

async function fetchShowQrCode() {
  const params =
    new URLSearchParams(
      window.location.search
    );

  const tenant =
    params.get(
      "tenant"
    );

  slowScanBanner =
    document.getElementById(
      "slowScanAlert"
    );

  slowScanText =
    document.getElementById(
      "slowScanText"
    );

  const slowScanCloseBtn =
    document.getElementById(
      "slowScanClose"
    );

  if (slowScanCloseBtn) {
    slowScanCloseBtn.addEventListener(
      "click",
      resetUI
    );
  }

  const machine =
    createMachine({
      initialState:
      states.LOADING,
      transitions,
      states:
      statesConfig,
    });

  try {
    let url =
      "/api/issuance";

    if (tenant) {
      url +=
        "?tenant=" +
        encodeURIComponent(
          tenant
        );
    }

    const response =
      await fetch(
        url,
        {
          method: "GET",
          headers: {
            Accept:
              "application/json"
          },
          cache: "no-store"
        }
      );

    if (!response.ok) {
      throw new Error(
        "HTTP error " +
        response.status
      );
    }

    const data =
      await response.json();

    const requestUri =
      data.requestUri;

    const qrImageUrl =
      data.qrImageUrl;

    currentSessionId =
      data.sessionId;

    if (
      !requestUri ||
      !qrImageUrl ||
      !currentSessionId
    ) {
      throw new Error(
        "Invalid issuance response"
      );
    }

    machine.send(
      events.LOAD_DONE
    );

    const qrImage =
      document.getElementById(
        "qrImage"
      );

    const qrBox =
      document.getElementById(
        "qrBox"
      );

    if (qrImage) {
      qrImage.onload =
        function () {
          qrImage.classList.remove(
            "placeholder",
            "placeholder-qr"
          );

          qrImage
            .parentElement
            ?.classList
            .remove(
              "placeholder-glow"
            );
        };

      qrImage.src =
        qrImageUrl;
    }

    if (qrBox) {
      qrBox.href =
        requestUri;

      qrBox.addEventListener(
        "click",
        async (event) => {
          event.preventDefault();

          machine.send(
            events.CLICK
          );

          try {
            await navigator
              .clipboard
              .writeText(
                requestUri
              );
          } catch (error) {
            console.error(
              "Clipboard write failed:",
              error
            );
          }

          const copyMessage =
            document.getElementById(
              "copyMessage"
            );

          if (copyMessage) {
            copyMessage
              .classList
              .remove(
                "opacity-0"
              );

            copyMessage
              .classList
              .add(
                "opacity-100"
              );

            setTimeout(
              () => {
                copyMessage
                  .classList
                  .remove(
                    "opacity-100"
                  );

                copyMessage
                  .classList
                  .add(
                    "opacity-0"
                  );
              },
              1500
            );
          }

          const isInIframe =
            window.self !==
            window.top;

          if (isInIframe) {
            window.parent.postMessage(
              {
                type: "OPEN",
                url: requestUri
              },
              "*"
            );
          } else {
            window.location.href =
              requestUri;
          }
        }
      );
    }

    const evtSource =
      new EventSource(
        "/api/status/" +
        encodeURIComponent(
          currentSessionId
        )
      );

    evtSource.onmessage =
      (event) => {
        let message;

        try {
          message =
            JSON.parse(
              event.data
            );
        } catch (error) {
          console.error(
            "Invalid status response:",
            error
          );

          return;
        }

        if (
          message.type ===
          "PENDING"
        ) {
          machine.send(
            events.PENDING
          );

          return;
        }

        if (
          message.type ===
          "SUCCEEDED"
        ) {
          evtSource.close();

          machine.send(
            events.SUCCESS
          );

          return;
        }

        if (
          message.type ===
          "FAILED"
        ) {
          evtSource.close();

          machine.send(
            events.FAILED
          );
        }
      };

    evtSource.onerror =
      (error) => {
        console.error(
          "Status stream error:",
          error
        );
      };
  } catch (error) {
    console.error(
      "Failed to create credential offer:",
      error
    );

    resetUI();

    if (slowScanText) {
      slowScanText.textContent =
        "Could not create the credential offer. Please reload the page.";
    }

    if (slowScanBanner) {
      slowScanBanner.classList.remove(
        "d-none"
      );
    }
  }
}

function fetchShowQrCodeOnLoad() {
  window.addEventListener(
    "load",
    fetchShowQrCode
  );
}

fetchShowQrCodeOnLoad();
